import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

import { type AppDispatch, type RootState, store } from 'reduxStore';
import { usePreviewVersionState } from 'components/organisms/AgentStream/context/PreviewVersionContext';

export const useLocalDispatch = () => useDispatch<AppDispatch>();

// If we are in preview version, we select from the context and if not we select from the store
export const useAppSelector: TypedUseSelectorHook<RootState> = selector => {
  const snapshot = usePreviewVersionState();
  const live = useSelector(selector);

  return snapshot
    ? selector({ ...store.getState(), ...snapshot } as RootState)
    : live;
};
